module.exports = "/components/components/linkedLocations-9cc7ab.html";